export default "__VITE_ASSET__D543QJdt__"